"use client"

import { LogOutIcon } from "lucide-react"
import { useTranslations } from "next-intl"

import { getLinkWithPrefixFromURLAndLocale } from "@/lib/link-utils/link-utils"

export default function StoryblokLogoutButton(props: { sbLocale: string }) {
  const t = useTranslations("storefront")
  const handleSubmit = async () => {
    const fallbackRedirectUrl = getLinkWithPrefixFromURLAndLocale("/", props.sbLocale)
    const logoutUrl =
      (process.env.NEXT_PUBLIC_BASE_PATH ?? "") + getLinkWithPrefixFromURLAndLocale("/api/auth/logout", props.sbLocale)

    try {
      const response = await fetch(logoutUrl, {
        method: "POST",
      })
      const redirectUrl = response.ok ? await response.text() : fallbackRedirectUrl
      window.location.replace(redirectUrl || fallbackRedirectUrl)
    } catch {
      window.location.replace(fallbackRedirectUrl)
    }
  }

  return (
    <button
      onClick={handleSubmit}
      className="group mt-2 flex w-full gap-x-3 rounded-md py-2 leading-6 hover:text-primary-hover"
    >
      <LogOutIcon className="size-6 shrink-0 text-primary group-hover:text-primary-hover" aria-hidden="true" />
      {t("account.nav.sign-out")}
    </button>
  )
}
